(function() {
  'use strict';

  const ARROW_LEFT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  const ARROW_RIGHT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function initGobabyGallery() {
    const mediaWrappers = document.querySelectorAll('.product__media-wrapper');
    
    mediaWrappers.forEach(function(wrapper) {
      if (wrapper.dataset.gobabyGallery === 'initialized') return;
      wrapper.dataset.gobabyGallery = 'initialized';

      const mediaList = wrapper.querySelector('.product__media-list');
      if (!mediaList) return;

      const thumbnailButtons = wrapper.querySelectorAll('.thumbnail-list__item button, .thumbnail-list [data-target]');
      const thumbnailItems = wrapper.querySelectorAll('.thumbnail-list__item');
      
      const mediaItems = mediaList.querySelectorAll('.product__media-item');
      const totalImages = thumbnailItems.length > 0 ? thumbnailItems.length : mediaItems.length;
      
      if (totalImages <= 1) return;

      mediaList.dataset.mediaCount = totalImages;

      const prevBtn = document.createElement('button');
      prevBtn.className = 'gobaby-gallery-arrow gobaby-gallery-arrow--prev';
      prevBtn.setAttribute('type', 'button');
      prevBtn.setAttribute('aria-label', 'Föregående bild');
      prevBtn.innerHTML = ARROW_LEFT_SVG;

      const nextBtn = document.createElement('button');
      nextBtn.className = 'gobaby-gallery-arrow gobaby-gallery-arrow--next';
      nextBtn.setAttribute('type', 'button');
      nextBtn.setAttribute('aria-label', 'Nästa bild');
      nextBtn.innerHTML = ARROW_RIGHT_SVG;

      const counter = document.createElement('div');
      counter.className = 'gobaby-gallery-counter';
      counter.dataset.total = totalImages;
      counter.textContent = '1 / ' + totalImages;

      mediaList.appendChild(prevBtn);
      mediaList.appendChild(nextBtn);
      mediaList.appendChild(counter);

      function getCurrentIndex() {
        for (let i = 0; i < thumbnailItems.length; i++) {
          const item = thumbnailItems[i];
          const button = item.querySelector('button') || item.querySelector('[data-target]');
          
          if (item.classList.contains('is-active') || 
              item.classList.contains('thumbnail-list__item--active') ||
              (button && (
                button.getAttribute('aria-current') === 'true' ||
                button.getAttribute('aria-pressed') === 'true' ||
                button.classList.contains('is-active')
              ))) {
            return i;
          }
        }
        return 0;
      }

      function updateCounter() {
        const current = getCurrentIndex() + 1;
        counter.textContent = current + ' / ' + totalImages;
      }

      // Cirkulär loop: när man kommer till slutet börjar man om från början
      function goToIndex(index) {
        let targetIndex;
        
        if (index < 0) {
          // Om vi går bakåt från bild 1 → hoppa till sista bilden
          targetIndex = totalImages - 1;
        } else if (index >= totalImages) {
          // Om vi går framåt från sista bilden → hoppa till första bilden
          targetIndex = 0;
        } else {
          targetIndex = index;
        }
        
        if (thumbnailItems[targetIndex]) {
          const button = thumbnailItems[targetIndex].querySelector('button') || 
                        thumbnailItems[targetIndex].querySelector('[data-target]') ||
                        thumbnailItems[targetIndex];
          if (button) {
            button.click();
            setTimeout(function() {
              updateCounter();
            }, 100);
            return;
          }
        }
        
        if (mediaItems[targetIndex]) {
          mediaItems[targetIndex].scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest', 
            inline: 'start' 
          });
          setTimeout(function() {
            updateCounter();
          }, 300);
        }
      }

      function handlePrev(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        goToIndex(getCurrentIndex() - 1);
        return false;
      }

      function handleNext(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        goToIndex(getCurrentIndex() + 1);
        return false;
      }

      prevBtn.addEventListener('click', handlePrev, true);
      prevBtn.addEventListener('mousedown', function(e) { e.stopPropagation(); }, true);
      prevBtn.addEventListener('touchstart', function(e) { e.stopPropagation(); }, { passive: true, capture: true });

      nextBtn.addEventListener('click', handleNext, true);
      nextBtn.addEventListener('mousedown', function(e) { e.stopPropagation(); }, true);
      nextBtn.addEventListener('touchstart', function(e) { e.stopPropagation(); }, { passive: true, capture: true });

      thumbnailButtons.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          setTimeout(function() {
            updateCounter();
          }, 150);
        });
      });

      const thumbObserver = new MutationObserver(function() {
        updateCounter();
      });
      
      thumbnailItems.forEach(function(item) {
        thumbObserver.observe(item, { 
          attributes: true, 
          attributeFilter: ['class', 'aria-current', 'aria-pressed'] 
        });
        const btn = item.querySelector('button');
        if (btn) {
          thumbObserver.observe(btn, { 
            attributes: true, 
            attributeFilter: ['class', 'aria-current', 'aria-pressed'] 
          });
        }
      });

      wrapper.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          goToIndex(getCurrentIndex() - 1);
        } else if (e.key === 'ArrowRight') {
          goToIndex(getCurrentIndex() + 1);
        }
      });

      setTimeout(function() {
        updateCounter();
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGobabyGallery);
  } else {
    initGobabyGallery();
  }

  document.addEventListener('shopify:section:load', initGobabyGallery);
  
  const observer = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && ((node.classList && node.classList.contains('product__media-wrapper')) || (node.querySelector && node.querySelector('.product__media-wrapper')))) {
            initGobabyGallery();
            return;
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();